<div class="page-title">
    <h1>{{ 'TITLES.CREATE_NEW_AGREEMENT' | translate }}</h1>
</div>

<app-form-container-centered>
    <app-simple-tabs
        [loading]="isSaving"
        [form]="agreementForm"
        [tabIndex]="tabIndex"
        [nextDisabled]="!isCurrentFormValid()"
        [nextHintLanguageKey]="'VALIDATION.REQUIRED_FIELDS'"
        [showNextHint]="!isCurrentFormValid()"
        (previous)="previous()"
        (next)="next()"
        (save)="save()"
        (cancel)="cancel()"
    >
        <app-simple-tab #agreementTypeForm [title]="'FEATURES.AGREEMENTS.TAB_CREATE_NEW_AGREEMENT' | translate">
            <app-new-agreement
                [detailsForm]="detailsForm"
                [showPotentialValidationMessages]="showPotentialValidationMessages[tabs.SelectType]"
            ></app-new-agreement>
        </app-simple-tab>
        <app-simple-tab #generalInfoForm [title]="'FEATURES.AGREEMENTS.TAB_GENERAL_INFO' | translate">
            <app-general-info
                *ngIf="showContent(tabs.GeneralInfo)"
                [agreementForm]="agreementForm"
                [showPotentialValidationMessages]="showPotentialValidationMessages[tabs.GeneralInfo]"
                (fileDialogStateChange)="onFileDialogStateChange($event)"
            ></app-general-info>
        </app-simple-tab>
        <app-simple-tab #periodsRenewalsForm [title]="'FEATURES.AGREEMENTS.TAB_PERIODS_RENEWALS' | translate">
            <app-new-agreement-periods-renewals
                *ngIf="showContent(tabs.PeriodsAndRenewals)"
                #periodsForm
                [agreementForm]="agreementForm"
                [showPotentialValidationMessages]="showPotentialValidationMessages[tabs.PeriodsAndRenewals]"
                (fileDialogStateChange)="onFileDialogStateChange($event)"
            ></app-new-agreement-periods-renewals>
        </app-simple-tab>
        <app-simple-tab #notesActivitiesForm [title]="'FEATURES.AGREEMENTS.TAB_NOTES_AND_ATTACHMENTS' | translate">
            <app-new-agreement-notes-activities
                [agreementForm]="agreementForm"
                [showPotentialValidationMessages]="showPotentialValidationMessages[tabs.NotesAndActivities]"
                (fileDialogStateChange)="onFileDialogStateChange($event)"
            ></app-new-agreement-notes-activities>
        </app-simple-tab>
        <app-simple-tab
            *ngIf="hasRiskAnalysis"
            #riskAnalysisForm
            [title]="'FEATURES.AGREEMENTS.TAB_RISK_ANALYSIS' | translate"
        >
            <app-new-agreement-risk-analysis [agreementForm]="agreementForm"></app-new-agreement-risk-analysis>
        </app-simple-tab>
    </app-simple-tabs>

    <div class="button-right-container">
        <button
            *ngIf="canGenerateMetaData && tabIndex > 0"
            [disabled]="generatingMetaData || !hasAITokens"
            (click)="generateMetaData($event, true)"
            class="icon"
            [title]="getGenerateMetaDataTooltip()"
            [ngClass]="{ loading: generatingMetaData }"
        >
            <span>{{ 'BUTTONS.GENERATE_METADATA' | translate }}</span>
        </button>
    </div>
</app-form-container-centered>
